export default {"src":"/_next/static/media/doctor_team.501e8fab.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};